import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const PlanningMissionService = {
  async getPlanning(state,statutMissionVal,dateDebut,dateFin) {
    try {
      const result = await axios.post(`${apiUrl}/planningMission/getliste`,{
        state:state.id,
        statutMissionVal:statutMissionVal.id,
        dateDebut:dateDebut,
        dateFin:dateFin
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getActivity() {
    try {
      const result = await axios.get(`${apiUrl}/planningMission/activity`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getCategory(category_mission_id) {
    try {
      const result = category_mission_id
        ? await axios.get(
            `${apiUrl}/planningMission/category/${category_mission_id}`
          )
        : await axios.get(`${apiUrl}/planningMission/category`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getDirection() {
    try {
      const result = await axios.get(`${apiUrl}/planningMission/direction`);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getServiceappui(id) {
    try {
      const result = await axios.post(`${apiUrl}/planningMission/serviceappui`,{id:id});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getServicelist(id) {
    try {
      const result = await axios.post(`${apiUrl}/planningMission/servicelist`,{id:id});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getService(id) {
    try {
      const result = await axios.post(`${apiUrl}/planningMission/service`,{id:id});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getdetails(id) {
    try {
      const result = await axios.get(`${apiUrl}/planningMission/detailsID/`+id);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getIntervenant(direction_id, service_id) {
    try {
      const result = await axios.post(
        `${apiUrl}/planningMission/intervenant`
      ,{
        direction:direction_id,
        service:service_id
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async saveMissionPlanning(formData) {
    try {
      const result = await axios.post(`${apiUrl}/planningMission`, formData);
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateMissionPlanning(formData) {
    try {
      const result = await axios.put(`${apiUrl}/planningMission`, formData);
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  
  async saveMissionPlanningAgenda(formData, mission_planning_id, modif) {
    try {
      const result = modif
        ? await axios.put(
            `${apiUrl}/planningMission/agenda/${mission_planning_id}`,
            formData
          )
        : await axios.post(
            `${apiUrl}/planningMission/agenda/${mission_planning_id}`,
            formData
          );
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getMissionPlanningDays(mission_planning_id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/days/${mission_planning_id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getMissionary(mission_planning_id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/missionary/${mission_planning_id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteMissionPlanning(mission_planning_id) {
    try {
      const result = await axios.delete(
        `${apiUrl}/planningMission/id/${mission_planning_id}`
      );
      if (result) {
        // TODO: replace result.data.message by the token
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getPlanningMissionById(mission_planning_id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/id/${mission_planning_id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async updatePlanningMissionById(mission_planning_id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/update/${mission_planning_id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getMissionPlanningId(mission_planning_id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/post/${mission_planning_id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getUserMission() {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/mission`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getObservation(id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/observation/`+id
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getObservationtdr(id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/observationtdr/`+id
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getAgendaMissionPlanning(mission_planning_id) {
    try {
      const result = await axios.get(
        `${apiUrl}/planningMission/agenda/${mission_planning_id}`
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async newtrd(id) {
    try {
      const result = await axios.get(
        `${apiUrl}/TDR/newtdraftervalidation/`+id
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getEtat(form) {
    try {
      const result = await axios.post(
        `${apiUrl}/MissionEtat`,{
         ligne:form.ligne,
         valeur:form.valeur, 
         datedebut:form.date_debut,
         datefin:form.date_fin,
         codemission:form.reference,
         status:form.status,
         direction:form.direction,
         destination:form.destination,
         directionmis:form.directionmiss,
         servicemis:form.servicemiss,
         functionid:form.functionid,
         region:form.region,
         district:form.district,
         commune:form.commune
         }
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async getEtatplanning(form) {
    
    try {
      const result = await axios.post(
        `${apiUrl}/MissionEtat/getEtatPlanning`,{
         datedebut:form.date_debut,
         datefin:form.date_fin,
         status:form.status,
         direction:form.directiondest,
         destination:form.destination,
         directionmis:form.direction,
         service:form.service
         }
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async tdr (id)
  {
      try{
          const result = await axios.get(`${apiUrl}/TDRMission/tdrviaplanning/${id}`);
          if (result) {
            return result.data;
          }
      }catch (error) {
          if (error.response) {
              return error.response.data;
          }
      }
  },
  
  async tdrexistant (id,idtdr)
  {
      try{
          const result = await axios.get(`${apiUrl}/TDRMission/tdrviaplanningexistant/${id}/${idtdr}`);
          if (result) {
            return result.data;
          }
      }catch (error) {
          if (error.response) {
              return error.response.data;
          }
      }
  },
  async agenda (id,planningdestination)
  {
      try{
          const result = await axios.get(`${apiUrl}/TDRMission/rattacheragenda/${id}/`+planningdestination);
          if (result) {
            return result.data;
          }
      }catch (error) {
          if (error.response) {
              return error.response.data;
          }
      }
  },
    async agendaexistant (id,idagenda)
  {
      try{
          const result = await axios.get(`${apiUrl}/TDRMission/rattacheragendaexistant/${id}/${idagenda}`);
          if (result) {
            return result.data;
          }
      }catch (error) {
          if (error.response) {
              return error.response.data;
          }
      }
  },
  async suivimission(form) {
    
    try {
      const result = await axios.post(
        `${apiUrl}/SuiviMission`,{
           data:form
         }
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

    async transport ()
    {
        try{
            const result = await axios.get(`${apiUrl}/Mission/listtransport`);
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
    async planningactive ()
    {
        try{
            const result = await axios.get(`${apiUrl}/PlanningMission/getplanningactive`);
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
     async insertraison (raison,id)
    {
        try{
            const result = await axios.post(`${apiUrl}/PlanningMission/insertraison/`+id,{
              raison:raison
            });
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
   async updatevalidationplanning(id)
    {
        try{
            const result = await axios.get(`${apiUrl}/PlanningMission/updateplanningvalidation/`+id);
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
    async verifdateplanning(section)
    {
        try{
            const result = await axios.post(`${apiUrl}/PlanningMission/verificationplanning`,{
              section:section
            });
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
    async getValidatedMissionsWithoutReport (section)
    {
        try{
            const result = await axios.post(`${apiUrl}/PlanningMission/getValidatedMissionsWithoutReport`,{
              section:section
            });
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },

    async updateMissionPlanningWithDerogation(dataderogation)
    {
       try{
            const result = await axios.put(`${apiUrl}/PlanningMission/submitDerogation`,
              dataderogation);
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
    async listfunction()
    {
       try{
            const result = await axios.get(`${apiUrl}/PlanningMission/listfunction`,);
            if (result) {
              return result.data;
            }
        }catch (error) {
            if (error.response) {
                return error.response.data;
            }
        }
    },
  
};

export default PlanningMissionService;
